<div class="p-card flex align-items-center flex-row-reverse flex-wrap gap-2">
  <app-active-user-avatar class="mr-2" size="large"></app-active-user-avatar>
  <p-button
    size="small"
    type="button"
    icon="fas fa-ellipsis-v"
    [rounded]="true"
    (click)="menu.toggle($event)"></p-button>
  <app-notification-button />
  <app-validation-badge />

  @if (userStore.canAccessUserManagement()) {
    <p-button
      size="small"
      tooltipPosition="left"
      pTooltip="Nutzer:innen verwalten"
      [rounded]="true"
      icon="fas fa-users"
      [routerLink]="[
        '/data-backend',
        { outlets: { overlay: 'nutzerverwaltung' } },
      ]"></p-button>
  }
  @if (userStore.canAccessUserManagement()) {
    <p-button
      size="small"
      tooltipPosition="left"
      pTooltip="Status aller Indikatoren"
      [rounded]="true"
      icon="fas fa-clipboard-list"
      [routerLink]="[
        '/data-backend',
        { outlets: { overlay: 'indikatoren-bericht' } },
      ]"></p-button>
  }

  <app-theme-switcher></app-theme-switcher>
  <app-global-search></app-global-search>

  @if (userStore.canAccessEntityAdder() && permissionStore.canAddAnything()) {
    <p-button
      size="small"
      tooltipPosition="left"
      pTooltip="neu anlegen"
      [rounded]="true"
      icon="fas fa-plus-circle"
      [raised]="true"
      [routerLink]="[
        '/data-backend',
        { outlets: { overlay: 'neu' } },
      ]"></p-button>
  }

  <h1 class="my-2 pl-2 text-primary flex align-items-center gap-2">
    <app-logo variant="icon" hStyleClass="h-3rem w-4rem" />
    <span>Datenpflege · {{ globalsStore.activeCommune()?.name }} </span>
  </h1>
</div>
<p-menu
  #menu
  styleClass="right-0 left-auto w-20rem"
  [model]="items"
  [popup]="true">
  <ng-template pTemplate="item" let-item>
    @if (item.url) {
      <a class="p-menuitem-link" target="_blank" [href]="item.url">
        <div class="flex align-items-baseline">
          <i class="p-menuitem-icon" [class]="item.icon"></i>
          <div>
            <span>{{ item.label }}</span>
            @if (item.sub) {
              <div class="text-xs text-color-secondary mt-2">
                {{ item.sub }}
              </div>
            }
          </div>
        </div>
      </a>
    } @else {
      <a
        class="p-menuitem-link"
        [routerLink]="item.routerLink"
        [target]="item.target || '_self'">
        <div class="flex align-items-center">
          <i class="p-menuitem-icon" [class]="item.icon"></i>
          <div>
            <span>{{ item.label }}</span>
            @if (item.sub) {
              <div class="text-xs text-color-secondary mt-2">
                {{ item.sub }}
              </div>
            }
          </div>
        </div>
      </a>
    }
  </ng-template>
</p-menu>
